import { store } from './store'

export const DRIVER_TYPE_ALL = 1
export const DRIVER_TYPE_APP = 2

export interface DriverProfileInput {
  placa?: string | null
  autorizacao?: string | null
  veiculo?: string | null
}

export function has_saved_driver_profile(): boolean {
  return Boolean(
    store.get('driver_placa')
    || store.get('driver_autorizacao')
    || store.get('driver_veiculo'),
  )
}

export function get_saved_driver_profile(): DriverProfileInput {
  return {
    placa: store.get('driver_placa'),
    autorizacao: store.get('driver_autorizacao'),
    veiculo: store.get('driver_veiculo'),
  }
}

export function get_driver_type(): number {
  const raw = Number(store.get('driver_tipo_motorista'))
  if (raw === DRIVER_TYPE_APP) return DRIVER_TYPE_APP
  if (raw === DRIVER_TYPE_ALL) return DRIVER_TYPE_ALL
  return has_saved_driver_profile() ? DRIVER_TYPE_APP : DRIVER_TYPE_ALL
}

export function start_driver_session(phone: string): void {
  if (store.get('driver_phone') !== phone) {
    store.set('driver_ev_navigation', null)
  }
  store.set('driver_phone', phone)
  store.set('driver_tipo_motorista', DRIVER_TYPE_ALL)
  store.set('driver_placa', null)
  store.set('driver_autorizacao', null)
  store.set('driver_veiculo', null)
  store.set('driver_offer_product_code', null)
  store.set('driver_offer_payment_id', null)
  store.set('driver_voucher', null)
}

export function activate_driver_app(profile: DriverProfileInput = {}): void {
  store.set('driver_tipo_motorista', DRIVER_TYPE_APP)
  store.set('driver_placa', profile.placa || null)
  store.set('driver_autorizacao', profile.autorizacao || null)
  store.set('driver_veiculo', profile.veiculo || null)
}

export function deactivate_driver_app(): void {
  store.set('driver_tipo_motorista', DRIVER_TYPE_ALL)
  store.set('driver_voucher', null)
}

export function clear_saved_driver_profile(): void {
  store.set('driver_placa', null)
  store.set('driver_autorizacao', null)
  store.set('driver_veiculo', null)
  store.set('driver_voucher', null)
}

export function reset_driver_session(): void {
	// O auth_token é da sessão de origem: sem limpar aqui, "Desconectar" e a exclusão
  // de dados deixavam o token guardado no localStorage (mesmo tratamento que
  // driver-offers dá a um 401 de autorização).
  store.set('auth_token', null)
  store.set('driver_auth_token', null)
  store.set('driver_phone', null)
  store.set('driver_tipo_motorista', null)
  store.set('driver_placa', null)
  store.set('driver_autorizacao', null)
  store.set('driver_veiculo', null)
  store.set('driver_offer_product_code', null)
  store.set('driver_offer_payment_id', null)
  store.set('driver_voucher', null)
  store.set('driver_ev_navigation', null)
}
